module.exports = __webpack_public_path__ + "static/couture04-42d9594427747e60d228713b46547353.png";